import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DashboardWidgetInstance } from '../models/dashboard-widget.types';
import { DashboardWidgetRegistryService } from '../registry/dashboard-widget-registry.service';

@Component({
  selector: 'jbm-dashboard-widget',
  templateUrl: './dashboard-widget.component.html',
})
export class JBMDashboardWidgetComponent {
  @Input() widget!: DashboardWidgetInstance;
  componentTitle: string = '';
  componentIcon: string = '';
  @Input() canMoveLeft: boolean = false;
  @Input() canMoveRight: boolean = false;
  @Input() canClose: boolean = false;
  @Output() dragStarted = new EventEmitter<DragEvent>();
  @Output() dragEnded = new EventEmitter<void>();
  @Output() remove = new EventEmitter<DashboardWidgetInstance>();
  @Output() changed = new EventEmitter<DashboardWidgetInstance>();
  @Output() moveLeft = new EventEmitter<void>();
  @Output() moveRight = new EventEmitter<void>();

  constructor(private readonly registry: DashboardWidgetRegistryService) {}

  get title(): string {
    return this.widget.title || this.componentTitle || this.registry.get(this.widget.type)?.title || 'Onbekende widget';
  }

  get icon(): string {
    return this.widget.icon || this.componentIcon || this.registry.get(this.widget.type)?.icon || 'fa-puzzle-piece';
  }

}
